var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6332 29C56.6332 44.8187 44.0324 57.6313 28.502 57.6313C12.9715 57.6313 0.370675 44.8187 0.370675 29C0.370675 13.1813 12.9715 0.368721 28.502 0.368721C44.0324 0.368721 56.6332 13.1813 56.6332 29Z",
    fill: "#B3D237",
    stroke: "#B3D237",
    strokeWidth: 0.737443
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5328 31.9226C32.5545 37.081 28.7773 40.4759 27.096 39.5052C25.4147 38.5345 26.466 33.5658 29.4442 28.4074C32.4225 23.249 36.1997 19.8541 37.881 20.8248C39.5623 21.7955 38.511 26.7642 35.5328 31.9226Z",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2949 33.6494L32.1107 36.4298",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2188 23.1711L41.0736 27.1288C41.0736 27.1288 38.6926 33.0007 37.3594 34.7536",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.096 39.5054L26.1973 41.0621",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6934 41.062H26.1968",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7227 17.7014H32.6859",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7227 22.1953H25.552",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7227 26.7451H25.552",
    stroke: "#1F1F21",
    strokeWidth: 0.737442,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.42498dd22e1098372b09f763676efe32.svg";
export { ForwardRef as ReactComponent };